import { render } from "./ProgressBarMultiColor.vue?vue&type=template&id=355710e8&ts=true"
import script from "./ProgressBarMultiColor.vue?vue&type=script&lang=ts"
export * from "./ProgressBarMultiColor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__